const messages = {
  name: 'Cost Center |||| Cost Centers',
  fields: {
    name: 'Cost Center Name',
    description: 'Description',
    creditBalance: 'Credit Balance',
    availableCredits: 'Credit Balance',
    reservedCredits: 'Reserved Credits',
    unpaidCreditLimit: 'Unpaid Credit Limit',
  },
  empty: 'No cost centers yet',
  invite: 'Add your first cost center',
  filters: {
    costCenterName: 'Cost Center Name',
  },
  columns: {
    actions: 'Actions',
    status: 'Status',
  },
  status: {
    active: 'Active',
    blocked: 'Blocked',
  },
  actions: {
    addCostCenter: 'Add Cost Center',
    creditTransactions: 'Credit transactions',
    viewAccounts: 'View accounts',
    topUp: 'Top Up',
    adjust: 'Adjust balance',
    block: 'Block',
    unblock: 'Unblock',
    delete: 'Delete',
  },
  accountsDialog: {
    title: 'Accounts of "%{name}"',
    empty: 'This cost center has no accounts.',
    count: '%{smart_count} account |||| %{smart_count} accounts',
  },
  notificationsExtra: {
    blockSucceeded: 'Balance blocked',
    blockFailed: 'Failed to block balance',
    unblockSucceeded: 'Balance unblocked',
    unblockFailed: 'Failed to unblock balance',
  },
  dialog: {
    title: 'Cost Center Details',
  },
  validation: {
    required: '%{field} is required',
    maxLength: '%{field} must be at most %{max} characters',
    minValue: '%{field} must be greater than or equal to %{min}',
    positive: '%{field} must be greater than 0',
  },
  create: { title: 'Create Cost Center' },
  edit: { title: 'Edit Cost Center' },
  sections: {
    basicInfo: 'Cost Center Details',
  },
  delete: {
    title: 'Delete cost center "%{recordName}"',
    content: 'Are you sure you want to delete this cost center? This action cannot be undone.',
  },
  notifications: {
    created: 'Cost Center created successfully',
    updated: 'Cost Center updated successfully',
    deleted: 'Cost Center deleted successfully',
  },
};

export default messages;
